import { configureStore } from '@reduxjs/toolkit';
import MastertableSlice from './MastertableSlice';
import VendorDataSlice from './VendorDataSlice';
import CreatePMPlan from './PreventiveMaintaince/CreatePMPlan';
import BreakdownSlice from './Breakdown/BreakdownSlice';
import NotificationSlice from './NotificationSlice';

const store = configureStore({
    reducer: {
        master: MastertableSlice,
        vendor: VendorDataSlice,
        pm: CreatePMPlan,
        bd: BreakdownSlice,
        notification: NotificationSlice
    },
});

export default store;
